import { Stack } from '@zet/design-system/layout'
import { B3, B4, SH3 } from '@zet/design-system/typography'
import moment from 'moment'

interface ArnStatusProps {
  askTitle: string
  askDescription: string
  date: string
}

const ArnStatus: React.FC<ArnStatusProps> = ({
  askTitle,
  askDescription,
  date,
}) => {
  return (
    <Stack className="bg-primary-10 px-4/2 rounded py-2">
      <B4 className="text-grays-60">
        {moment.utc(date).format('DD-MMM-YYYY')}
      </B4>
      <SH3 className="text-grays-80">{askTitle}</SH3>
      <B3 className="text-grays-60">{askDescription}</B3>
    </Stack>
  )
}

export default ArnStatus
